import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useRanking } from '../hooks/useRanking';
import { Player } from '../types/game';

const RankingContainer = styled.div`
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 20px auto;
`;

const Title = styled.h2`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 1.8rem;
`;

const RankingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

interface RankingItemProps {
  color?: string;
}

const RankingItem = styled(motion.div)<RankingItemProps>`
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 4px solid ${props => props.color || '#ddd'};
`;

const Rank = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  color: #666;
  width: 40px;
`;

const PlayerInfo = styled.div`
  flex: 1;
  margin-left: 15px;
`;

const PlayerName = styled.div`
  font-weight: 600;
  color: #333;
`;

const PlayerStats = styled.div`
  font-size: 0.9rem;
  color: #666;
  margin-top: 2px;
`;

const Score = styled.div`
  font-size: 1.1rem;
  font-weight: bold;
  color: #4CAF50;
`;

const EmptyMessage = styled.div`
  text-align: center;
  color: #999;
  padding: 40px;
  font-size: 1.1rem;
`;

interface RankingBoardProps {
  show: boolean;
}

const RankingBoard: React.FC<RankingBoardProps> = ({ show }) => {
  const { rankings, loading } = useRanking();

  if (!show || loading) {
    return null;
  }

  const getRankColor = (rank: number) => {
    switch (rank) {
      case 1: return '#FFD700';
      case 2: return '#C0C0C0';
      case 3: return '#CD7F32';
      default: return '#4CAF50';
    }
  };

  return (
    <RankingContainer>
      <Title>🏆 최고 점수</Title>
      
      <RankingList>
        {rankings.length === 0 ? (
          <EmptyMessage>아직 기록이 없습니다. 게임을 시작해보세요!</EmptyMessage>
        ) : (
          rankings.map((player: Player, index: number) => (
            <RankingItem
              key={player.id}
              color={getRankColor(index + 1)}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
            >
              <Rank>#{index + 1}</Rank>
              <PlayerInfo>
                <PlayerName>{player.name}</PlayerName>
                <PlayerStats>
                  반응속도: {player.reactionTime}ms
                </PlayerStats>
              </PlayerInfo>
              <Score>{player.score}점</Score>
            </RankingItem>
          ))
        )}
      </RankingList>
    </RankingContainer>
  );
};

export default RankingBoard;